(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 3613:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4340);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ Main; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.0_biqbaboplfbrettd7655fr4n2y/node_modules/next/link.js
var next_link = __webpack_require__(4588);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.0_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var next_router = __webpack_require__(8295);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
;// CONCATENATED MODULE: ./src/components/header.tsx




var Header = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), menuIsOpen = ref[0], setMenusIsOpen = ref[1];
    (0,react.useEffect)(function() {
        router.events.on("routeChangeComplete", function() {
            return setMenusIsOpen(false);
        });
        router.events.on("routeChangeError", function() {
            return setMenusIsOpen(false);
        });
        return function() {
            router.events.off("routeChangeComplete", function() {
                return setMenusIsOpen(false);
            });
            router.events.off("routeChangeError", function() {
                return setMenusIsOpen(false);
            });
        };
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "flex justify-between items-center py-5 border-b-2 md:items-baseline border-b-slate-200 px-3 md:px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "p-0 m-0 text-4xl font-extrabold text-transparent lowercase bg-clip-text bg-gradient-to-r from-rose-400 via-indigo-500 to-purple-600 md:inline",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: "chris bailey"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "flex relative z-50 items-center mr-2 space-x-2 w-6 h-6 lg:hidden focus:outline-none",
                onClick: function() {
                    return setMenusIsOpen(!menuIsOpen);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex relative justify-center items-center w-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute w-full h-[2px] bg-current transition transform ".concat(menuIsOpen ? "translate-y-0 rotate-45" : "-translate-y-2")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute w-full h-[2px] bg-current transition transform ".concat(menuIsOpen ? "opacity-0 translate-x-3" : "opacity-100")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute w-full h-[2px] bg-current transition transform ".concat(menuIsOpen ? "translate-y-0 -rotate-45" : "translate-y-2")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "".concat(menuIsOpen ? "grid" : "invisible", " absolute top-0 left-0 z-40 md:visible md:block place-items-center w-screen h-screen bg-white md:relative md:top-auto md:left-auto md:w-auto md:h-auto md:bg-transparent"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "flex flex-col gap-3 justify-center md:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-2xl md:text-lg link__gradient",
                                    children: "home"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/writing",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-2xl md:text-lg link__gradient",
                                    children: "writing"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/projects",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-2xl md:text-lg link__gradient",
                                    children: "projects"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/about",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-2xl md:text-lg link__gradient",
                                    children: "about"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/layouts/main.tsx


var Main = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col mx-auto max-w-[65ch]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "px-3 md:px-0 mt-8",
                    children: children
                })
            ]
        })
    });
};


/***/ }),

/***/ 4340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4256);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4588);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _layouts_main__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9802);




var Home = function(param) {
    var posts = param.posts;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "chrisbailey.dev"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "personal blog and portfolio site of chris bailey. a full stack(ish) web developer out of michigan"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_main__WEBPACK_IMPORTED_MODULE_3__/* .Main */ .o, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-3xl font-extrabold text-indigo-500 lowercase",
                            children: "Recent Posts"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 gap-4 mt-3 md:grid-cols-2",
                            children: posts.map(function(post) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                                    className: "flex flex-col border-b-2 transition-all duration-300 ease-in-out border-b-gray-200 hover:border-b-slate-500",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/post/".concat(post.slug.current),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "text-xl font-bold transition-all duration-300 ease-in-out hover:text-rose-600",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    children: post.title
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "my-[.5em]",
                                            children: post.description
                                        })
                                    ]
                                }, post._id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [572,774,888,179], function() { return __webpack_exec__(3613); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);